import { render, staticRenderFns } from "./TopNavNotificationBarDeletionWarning.vue?vue&type=template&id=6899ef85&"
import script from "./TopNavNotificationBarDeletionWarning.vue?vue&type=script&lang=ts&"
export * from "./TopNavNotificationBarDeletionWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports